import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
declare let gapi: any;
declare let google: any;

import { AuthenticationService } from '../_services';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  public userData: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  
  ngAfterViewInit() {
    // reset login status
    setTimeout(() => {
      this.authenticationService.logout();
    });
    google.accounts.id.initialize({
      client_id: "81881082439-tqbtqf24dqvoj9r74imo7qb66lo75kb2.apps.googleusercontent.com",
      callback: this.onSignIn.bind(this)
    });
    google.accounts.id.renderButton(
      document.getElementById("g_id_signin"),
      { type: "standard", text: "signin_with", theme: "outline", 
      size: "medium", width: "250"}
    )
    google.accounts.id.prompt(); // also display the One Tap dialog
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    console.log('Submit form login');
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data.id) {
            this.router.navigate([this.returnUrl]);
          } else {
            alert('Usuario o contraseña no válido: ' + data.message);
          }
        },
        error => {
          this.loading = false;
        }
      );
  }
  public onSignIn (response: any) {
    let base64Url = response.credential.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    let responsePayload = JSON.parse(jsonPayload);

    const user = {};
    const that = this;
    // const auth2 = gapi.auth2.getAuthInstance();
    let username: string;

    ((u, p) => {
      u['id'] = p.sub;
      u['name'] = p.name;
      u['email'] = p.email;
      u['imageUrl'] = p.picture;
      u['givenName'] = p.given_name;
      u['familyName'] = p.family_name;
      u['token'] = response.credential;
    })(user, responsePayload);
    this.authenticationService.verifyToken(user['token']).subscribe(data => {
        console.log(data);
        that.userData = data;
        username = that.userData.username;
        that.userData.googleUser = user
        if (!(that.userData.creado == null)) {
          if (that.userData.creado) {
          alert('¡Gracias por registrarte! Estamos procesando tus datos.');
          } else {
          alert(
            'Su usuario ' +
              username +
              ' se encuentra deshabilitado. Deberá esperar que sea autorizado por los administradores.'
          );
          }
          // auth2.signOut().then(function() {
          //   console.log('User signed out.');
          // });
        } else {
          // login successful if there's a jwt token in the response
          that.authenticationService.loguearUsuario(that.userData);
          this.router.navigate(['/inicio']);
        }
      });
    console.log(user);
    // user.save();
    // this.goHome();
  }
}
